import React, { useRef,useEffect, useState } from 'react';
import Home from "../../components/Dashboard/Home"
import PersonalizedWorkoutProgram from "../../components/exercice/PersonalizeWorkoutProgram"
import { Col, Container, Row } from "react-bootstrap"
import UpgradeAccountNotise from "./dashboardAnalyse/UpgradeAccountNotise"
import Widget from "./dashboardAnalyse/Widget"
import LiveUsers from "./dashboardAnalyse/LiveUsers"
import AudiencesMetrics from "./dashboardAnalyse/AudiencesMetrics"
import AudiencesSessions from "./dashboardAnalyse/AudiencesSessions"
import NutritionDashboard from "./dashboardAnalyse/NutritionDashboard"

import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";

import { GetAllDietPlanByUser, GetDailyDataDashUser } from "../../../core/store/diet/dietPan/thunk";



const Accueil = () => {





    
const dispatch = useDispatch();

const selectLayoutState = (state) => state;
const DashboardNutritionnalData = createSelector(
      selectLayoutState,
      (state) => ({
        error: state.DietPlan.error,
        loading: state.DietPlan.loading,

dietPlans: state.DietPlan,
data: state,
        
 })
  ); 

 
  useEffect(() => {
    console.log("Dispatching GetAllDietPlanServices...");
    const userId = JSON.parse(sessionStorage.getItem('authUser'))?.data?.userId;
    console.log("Dispatching GetAllDietPlanServices...", userId);

    // Vérifier si userId existe avant de dispatcher l'action
    if (userId) {
      dispatch(GetAllDietPlanByUser(userId))
      .then((result) => {
        // Traiter le succès ici
        console.log('Succès"""":', result.payload);  // Le résultat de l'API
        
      })
      .catch((error) => {
        // Gérer l'erreur ici
        console.error('Erreur:', error);
      });
     
    } else {
      console.error('User ID not found in sessionStorage');
    }
  }, [dispatch]);
  
  const { error, loading, dietPlans } = useSelector(DashboardNutritionnalData);

  console.log("State from useSelector:",  useSelector(DashboardNutritionnalData));
  
    

    return(
        // <Home/>
        // <PersonalizedWorkoutProgram/>

        <React.Fragment>
            <div className="page-content">
                
              
                    {/* <BreadCrumb title="Analytics" pageTitle="Dashboards" /> */}
                    <Row className='mb-0'>                                             
                             {/* <UpgradeAccountNotise /> */}
                             <NutritionDashboard dietPlans={dietPlans} />
                               
                    </Row>
                    {/* <Row className='mb-2'>                                             
                            <Widget />        
                    </Row> */}
                    
                    {/* <Row className='mb-2'>
                       <LiveUsers />
                  
                    </Row>
                    <Row className='mb-2'>                   
                    <AudiencesMetrics />
                    </Row>
                    <Row className='mb-2'>             
                        <AudiencesSessions /> 
                    </Row> */}
                    {/* <Row>
                        <UsersByDevice />
                        <TopReferrals />
                        <TopPages />
                    </Row> */}
               
            </div>
        </React.Fragment>
    )
}
export default Accueil